
/* 
 *  Hook para verificar que el token del usuario no haya expirado y
 *  aún sea válido.  Se debe llamar cada vez que se ingrese a una opción
 *  que requiera autentificación.
*/

import { useEffect } from 'react'
import { useValue } from '../context/ContextProvider'
import { jwtDecode } from 'jwt-decode'

const useCheckToken = () => {
    //console.log('---------->>> useCheckToken');
    const { state: { currentUser }, dispatch } = useValue();
    useEffect(() => {
        if (currentUser) {
            const decodedToken = jwtDecode(currentUser.token);
            //console.log(decodedToken);
            if(decodedToken.exp*1000 < new Date().getTime()) {
                dispatch({type:'UPDATE_USER', payload:null})
            }
        }
    }, []);
}

export default useCheckToken